const getters = {
    getMasterEmailGroupData: (state) => {
      return state.masterEmailgroup;
    },
    getGroupBasedData: (state) => {
      return state.groupsBased;
    },
    getMasterJournalTypeData: (state) => {
      return state.journalType;
    },
    getMasterJournalHeaderListData: (state) => {
      return state.journalHeaderList;
    },
    getMasterJournalLineListData: (state) => {
      return state.journalLineList;
    },
    getMasterJournalPlanSchemeListData: (state) => {
      return state.journalPlanSchemeList;
    },
    getHierarchyHeaderMasterData: (state) => {
      return state.hierarchyMasterHeaderList;
    },
    getHierarchyLineItemMasterData: (state) => {
      return state.hierarchyMasterLineItemList;
    },
    getHierarchyHeaderItem: (state) => {
      return state.hierarchyHeaderItem;
    },
    getTargetPlanningHeaderListData: (state) => {
      return state.targetPlanningHeaderList;
    },
    getTargetPlanningLineListData: (state) => {
      return state.targetPlanningLineList;
    },
    getMasterEmailGropDropDownData: (state) => {
      return state.masterEmailGropDropDown;
    },
    getMasterTargetDeploymentData: (state) => {
      return state.masterTargetDeploymentDropDown;
    },
    getTargetDeploymentHeaderListData: (state) => {
      return state.targetDeploymentHeaderList;
    },
    getTargetDeploymentLineDynamicHeader: (state) => {
      return state.targetDeploymentLineDynamicHeaderList;
    },
    getTargetDeploymentLineDynamicListData: (state) => {
      return state.targetDeploymentLineDynamicList;
    },
  };
  
  export default getters;
  